module.exports = __webpack_public_path__ + "static/media/B_food_1.72d279a4.png";